import { createSlice } from '@reduxjs/toolkit'
import { fetchCustomerList, fetchUserPoints, fetchReport, fetchCreatorTypes, fetchCreatorTypeHistory } from './asyncAction'
import { initialState } from './initState'

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    selectCustomer: (state, action) => {
      state.selectedCustomer = action.payload
    },
    openAddPointDialog: (state, action) => {
      state.isOpenAddPointDialog = action.payload
    },
    setCreatorTypeModal: (state, action) => {
      state.modelOpened = action.payload
    },
    setUpload: (state, action) => {
      state.isUploading = action.payload
    },
    setDownload: (state, action) => {
      state.isDownloading = action.payload
    },
    setCreatorTypeId: (state, action) => {
      state.creatorTypeId = action.payload
    },
    setIsBlocked: (state, action) => {
      state.isBlocked = action.payload
    },
    setEkycStatus: (state, action) => {
      state.ekycStatus = action.payload
    },
    openModalCreatorType: (state, action) => {
      state.isOpenModalCreatorType = action.payload
    },
    setCreatorTypeEdit: (state, action) => {
      state.creatorTypeEdit = action.payload
    },
    setCreatorTypeEditDetail: (state, action) => {
      state.creatorTypeEditDetail = action.payload
    },
    openModalCreatorTypeEdit: (state, action) => {
      state.isOpenModalCreatorTypeEdit = action.payload
    },
    setCreatorTypeDeleteId: (state, action) => {
      state.creatorTypeDeleteId = action.payload
    },
    openModalCreatorTypeDelete: (state, action) => {
      state.isOpenModalCreatorTypeDelete = action.payload
    },
    setOrderField: (state, action) => {
      state.orderField = action.payload
    },
    setorderDirection: (state, action) => {
      state.orderDirection = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCustomerList.fulfilled, (state, action) => {
      state.customerList = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalPage = action.payload.totalPage
      state.totalRecords = action.payload.totalRecords
    }).addCase(fetchUserPoints.fulfilled, (state, action) => {
      state.userPoints = action.payload.data
      state.pageIndex = action.payload.pageIndex
      state.pageSize = action.payload.pageSize
      state.totalPage = action.payload.totalPage
      state.totalRecords = action.payload.totalRecords
    }).addCase(fetchReport.fulfilled, (state, action) => {
      state.reports = action.payload.data
    }).addCase(fetchCreatorTypes.fulfilled, (state, action) => {
      state.creatorTypes = action.payload.data
    }).addCase(fetchCreatorTypeHistory.fulfilled, (state, action) => {
      state.creatorTypeHistoryList = action.payload.data
      state.creatorTypeHistoryPageIndex = action.payload.pageIndex
      state.creatorTypeHistoryPageSize = action.payload.pageSize
      state.creatorTypeHistoryTotalPage = action.payload.totalPage
      state.creatorTypeHistoryTotalRecords = action.payload.totalRecords
    })
  }
})

export * from './asyncAction'

export const {
  selectCustomer,
  openAddPointDialog,
  setCreatorTypeModal,
  setUpload,
  setDownload,
  setCreatorTypeId,
  setIsBlocked,
  setEkycStatus,
  openModalCreatorType,
  openModalCreatorTypeEdit,
  setCreatorTypeEdit,
  openModalCreatorTypeDelete,
  setCreatorTypeDeleteId,
  setCreatorTypeEditDetail,
  setorderDirection,
  setOrderField
} = customerSlice.actions

export const customerReducer = customerSlice.reducer
